// extracted by mini-css-extract-plugin
export default {"TeamContainer":"team_TeamContainer__EuozZ","TeamCard":"team_TeamCard__ozGVI"};